import { IconQuestionMarkFilled } from '@iwoca/icons';

import { TappableTooltip } from '../../../../../components/TappableTooltip/TappableTooltip';
import { CustomerRow } from '../../../CustomersV2.types';

/**
 * Dashes for a cell with nothing to show, with a tooltip explaining why.
 *
 * Declined buyers get the dashes alone — no "why is this empty?" tooltip, since
 * the reason (declined) is already spelled out in the row.
 */
export const EmptyValueDash = ({
  row,
  reason,
}: {
  row: CustomerRow;
  reason: string;
}) => (
  <div className="flex items-center gap-l text-structure-80">
    ----------
    {row.application_stage.value !== 'declined' && (
      <span className="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-primary-40">
        {/* `fixed` so the bubble escapes the table's overflow: hidden, and so
            the flip boundary is the viewport rather than the table — inside
            the table the top rows had no room above, and Orion leaves
            data-popper-placement at the requested value when it flips,
            which inverts the arrow. */}
        <TappableTooltip
          className="text-primary-10"
          content={reason}
          placement="top"
          strategy="fixed"
        >
          <IconQuestionMarkFilled fill="primary-10" height="18" width="18" />
        </TappableTooltip>
      </span>
    )}
  </div>
);
